import { Label } from "ui/components/label";
import { cn } from "utils";

export const ViewField = ({ label, value, className }) => {
  if (value === null || value === undefined) {
    return null;
  }
  return (
    <div className="space-y-2">
      <label className="text-sm text-muted-foreground">{label}</label>
      <p className={cn("text-sm font-medium text-foreground", className)}>
        {value}
      </p>
    </div>
  );
};

export const ReadField = ({ label, children, className }) => {
 
  return (
    <div className="space-y-2">
      <label className="text-sm text-muted-foreground">{label}</label>
      <p className={cn("text-sm font-medium text-foreground", className)}>
        {children}
      </p>
    </div>
  );
};
